import HttpRequest from "@/api/axios";

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);

export default {
    //招聘配置
    jobConfig(data)
    {
        return axios.request({
            url: "jobs/search-config",
            data
        })
    },
    resume(data)
    {
        return axios.request({
            url: "jobs/resume",
            data
        })
    },
    resumeCheck(data)
    {
        return axios.request({
            url: "jobs/resume-check",
            method: "post",
            data
        })
    },
    //招聘列表
    jobList(data)
    {
        return axios.request({
            url: "jobs/list",
            data
        })
    },
    jobSave(data)
    {
        return axios.request({
            url: "jobs/save",
            method: "post",
            data
        })
    },
    jobdetail(data)
    {
        return axios.request({
            url: "jobs/detail",
            method: "post",
            data
        })
    },
    jobApply(data)
    {
        return axios.request({
            url: "jobs/apply",
            method: "post",
            data
        })
    },
    resumeList(data)
    {
        return axios.request({
            url: "jobs/resume-list",
            method: "get",
            data
        })
    },
    resumeDetail(data)
    {
        return axios.request({
            url: "jobs/resume-detail",
            method: "post",
            data
        })
    }
}
